export async function fetchJSON(url, options) {
    try {
        return url ? await fetchJSONUnsafe(url, options) : null;
    }
    catch (err) {
        console.error(err);
    }
    return null;
}
export const fetchJSONUnsafe = async (url, options) => {
    const response = await fetch(url, {
        ...options,
        headers: {
            ...options?.headers,
            'Content-Type': 'application/json',
        },
    });
    return response.json();
};
//# sourceMappingURL=fetchJSON.js.map